import {
  excludeQueryParams,
  useQueryParamsCallback,
  useSearch,
} from '@aboutyou/router';
import {OneOf} from '@aboutyou/utils';
import {useCallback} from 'react';

type UrlParams = OneOf<
  {includedUrlParams: Set<string>},
  {excludeUrlParams: Set<string>}
>;

export const useMergedPath = () => {
  const getQueryParams = useQueryParamsCallback();
  const search = useSearch();

  return useCallback(
    ({path, config}: {path: string; config?: UrlParams}) => {
      if (config?.includedUrlParams) {
        const existingParams = new URLSearchParams(getQueryParams());
        const [basePath, search] = path.split('?');
        const newParams = new URLSearchParams(search);

        existingParams.forEach((value, key) => {
          if (config.includedUrlParams.has(key)) {
            newParams.set(key, value);
          }
        });

        if (!existingParams.toString()) {
          return basePath || '/';
        }

        return `${basePath}?${newParams}`;
      }

      const existingParams = config?.excludeUrlParams
        ? excludeQueryParams(getQueryParams(), config.excludeUrlParams)
        : getQueryParams();

      const [basePath, search] = path.split('?');

      const newParams = new URLSearchParams(search);

      newParams.forEach((value, key) => {
        existingParams.set(key, value);
      });

      if (!existingParams.toString()) {
        return basePath || '/';
      }

      return `${basePath}?${existingParams}`;
    },
    [search],
  );
};
